import { connect } from 'react-redux'
import { getLocale } from 'redux-polyglot'
import {
  getIsSaleChanging,
  getIsSaleFetched,
  getLoggedIn
} from 'store/selectors'

const mapStateToProps = state => ({
  isLoggedIn: getLoggedIn(state),
  isSaleChanging: getIsSaleChanging(state),
  isSaleFetched: getIsSaleFetched(state),
  locale: getLocale(state)
})

export default connect(mapStateToProps)
